/**
 * <s-category-search>
 * Wraps the search page query field when a homepage category link opened the page.
 * The category query (data-base) rides in a hidden `q` field so the visible box shows
 * only what the shopper typed. Typing combines both as `(category) AND (typed)`, so the
 * search stays inside the category, ahead of s-live-form's delegated input listener.
 * The clear button resets to the plain category query instead of blanking `q`.
 */
class CategorySearch extends HTMLElement {
  connectedCallback() {
    this.visible = this.querySelector('[data-category-visible]');
    this.hidden = this.querySelector('[data-category-query]');
    this.base = this.dataset.base || '';
    if (!this.visible || !this.hidden || !this.base) return;

    this.sync = () => {
      const typed = this.visible.value.replace(/[()]/g, ' ').trim();
      this.hidden.value = typed ? `(${this.base}) AND (${typed})` : this.base;
    };

    this.onClick = (event) => {
      if (!event.target.closest('[data-clear-search]')) return;
      // Handle clear here so the category query survives; s-live-form would blank q.
      event.stopPropagation();
      this.visible.value = '';
      this.visible.dispatchEvent(new Event('input', { bubbles: true }));
      this.visible.focus();
    };

    this.visible.addEventListener('input', this.sync);
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    if (this.sync) this.visible?.removeEventListener('input', this.sync);
    if (this.onClick) this.removeEventListener('click', this.onClick);
  }
}

if (!customElements.get('s-category-search')) customElements.define('s-category-search', CategorySearch);
